import { Table } from "reactstrap";
import InvoiceHeadData from "./InvoiceHeadData";
import { Image, LI, UL } from "../../../../../AbstractElements";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import { dynamicImage } from "../../../../../Utils";

const InvoiceHead = () => {
  return (
    <tr>
      <td className="p-0">
        <Table borderless style={{ width: "100%" }}>
          <tbody>
            <tr style={{ padding: "28px 0 5px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <td className="p-0">
                <Image className="img-fluid for-light" src={dynamicImage(`logo/logo.png`)} alt="logo-light" />
                <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo_dark.png`)} alt="logo-dark" />
              </td>
              <td className="p-0">
                <UL className="simple-list flex-row" style={{ listStyle: "none", display: "flex", alignItems: "center", background: "linear-gradient(291deg,  #1a5f7f 21.2%, #1a5f7f 83.92%)", padding: "31px 80px", borderBottomLeftRadius: 100, gap: 28 }}>
                  <LI>
                    <SvgIcon className="stroke-icon" iconId="call" style={{ height: 14, width: 14, fill: "#fff", marginRight: 10 }} />
                    <span style={{ color: "#FFFFFF", fontWeight: 500, fontSize: 16 }}>(239) 555-0108</span>
                  </LI>
                  <LI style={{ borderLeft: "1px solid rgba(255, 255, 255, 0.3)", borderRight: "1px solid rgba(255, 255, 255, 0.3)", padding: "0 22px" }}>
                    <SvgIcon iconId="email-box" style={{ height: 16, width: 16, fill: "#fff", marginRight: 10 }} />
                    <span style={{ color: "#FFFFFF", fontWeight: 500, fontSize: 16 }}>Moscow@themesforest.com</span>
                  </LI>
                  <LI>
                    <SvgIcon iconId="web" style={{ height: 16, width: 16, fill: "#fff", marginRight: 10 }} />
                    <span style={{ color: "#FFFFFF", fontWeight: 500, fontSize: 16 }}>Website: www.Moscowthemes.com</span>
                  </LI>
                </UL>
              </td>
            </tr>
            <InvoiceHeadData />
          </tbody>
        </Table>
      </td>
    </tr>
  );
};

export default InvoiceHead;
